import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * CompsApiDetail 通用API接口详情面板组件
 * 用于显示接口的详细信息，包括参数和响应结构
 */
import React from "react";
import { Table, Typography, Tag, Space, Card } from "antd";
import { COMPONENT_OUTLINE_BORDER } from "../theme/componentBorders";
const { Title, Text } = Typography;
// 方法颜色映射
const METHOD_COLORS = {
    GET: "blue",
    POST: "green",
    PUT: "orange",
    DELETE: "red",
    PATCH: "purple",
};
const CompsApiDetail = ({ title = "接口详情", api, height = "100%", }) => {
    // 参数表格列配置
    const paramColumns = [
        {
            title: "参数名",
            dataIndex: "name",
            key: "name",
            width: 150,
            render: (text, record) => (_jsxs(Space, { children: [_jsx(Text, { strong: true, children: text }), record.required && _jsx(Tag, { color: "red", children: "\u5FC5\u586B" })] })),
        },
        {
            title: "类型",
            dataIndex: "type",
            key: "type",
            width: 100,
            render: (text) => _jsx(Tag, { color: "cyan", children: text }),
        },
        {
            title: "描述",
            dataIndex: "description",
            key: "description",
        },
        {
            title: "示例值",
            dataIndex: "example",
            key: "example",
            width: 150,
            render: (text) => (text ? _jsx(Text, { code: true, children: text }) : "-"),
        },
    ];
    // 响应字段表格列配置
    const responseColumns = [
        {
            title: "字段名",
            dataIndex: "name",
            key: "name",
            width: 200,
            render: (text) => _jsx(Text, { code: true, children: text }),
        },
        {
            title: "类型",
            dataIndex: "type",
            key: "type",
            width: 100,
            render: (text) => _jsx(Tag, { color: "cyan", children: text }),
        },
        {
            title: "描述",
            dataIndex: "description",
            key: "description",
        },
        {
            title: "示例值",
            dataIndex: "example",
            key: "example",
            width: 150,
            render: (text) => (text ? _jsx(Text, { code: true, children: text }) : "-"),
        },
    ];
    return (_jsx(Card, { title: title, style: {
            flex: 1,
            height,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
        }, bodyStyle: { flex: 1, overflow: "auto", padding: 16 }, children: api ? (_jsxs("div", { style: { height: "100%", overflow: "auto" }, children: [_jsxs(Space, { direction: "vertical", size: 16, style: { width: "100%", marginBottom: "24px" }, children: [_jsxs("div", { children: [_jsx(Title, { level: 4, style: { marginTop: 0, marginBottom: "8px" }, children: _jsxs(Space, { children: [_jsx(Tag, { color: METHOD_COLORS[api.method], children: api.method }), api.name] }) }), _jsx(Text, { type: "secondary", children: api.description })] }), _jsxs("div", { children: [_jsx(Text, { strong: true, children: "\u63A5\u53E3\u8DEF\u5F84\uFF1A" }), _jsx(Text, { code: true, style: { fontSize: "14px", marginLeft: "8px" }, children: api.path })] }), api.requiredPermission && (_jsxs("div", { children: [_jsx(Text, { strong: true, children: "\u6240\u9700\u6743\u9650\uFF1A" }), _jsx(Tag, { color: "gold", style: { marginLeft: "8px" }, children: api.requiredPermission })] }))] }), api.pathParams && api.pathParams.length > 0 && (_jsxs("div", { style: { marginBottom: "24px" }, children: [_jsx(Title, { level: 5, children: "Path \u53C2\u6570" }), _jsx(Table, { size: "small", columns: paramColumns, dataSource: api.pathParams, pagination: false, rowKey: "name", bordered: true })] })), api.queryParams && api.queryParams.length > 0 && (_jsxs("div", { style: { marginBottom: "24px" }, children: [_jsx(Title, { level: 5, children: "Query \u53C2\u6570" }), _jsx(Table, { size: "small", columns: paramColumns, dataSource: api.queryParams, pagination: false, rowKey: "name", bordered: true })] })), api.bodyParams && api.bodyParams.length > 0 && (_jsxs("div", { style: { marginBottom: "24px" }, children: [_jsx(Title, { level: 5, children: "Body \u53C2\u6570" }), _jsx(Table, { size: "small", columns: paramColumns, dataSource: api.bodyParams, pagination: false, rowKey: "name", bordered: true })] })), _jsxs("div", { style: { marginBottom: "24px" }, children: [_jsx(Title, { level: 5, children: "\u54CD\u5E94\u6570\u636E\u7ED3\u6784" }), _jsx(Table, { size: "small", columns: responseColumns, dataSource: api.responseFields, pagination: false, rowKey: "name", bordered: true })] }), api.responseExample && (_jsxs("div", { style: { marginBottom: "24px" }, children: [_jsx(Title, { level: 5, children: "\u54CD\u5E94\u6570\u636E\u793A\u4F8B" }), _jsx(Card, { size: "small", style: {
                                backgroundColor: "#f5f5f5",
                                border: COMPONENT_OUTLINE_BORDER,
                            }, bodyStyle: { padding: "12px" }, children: _jsx("pre", { style: {
                                    margin: 0,
                                    padding: 0,
                                    fontSize: "13px",
                                    lineHeight: "1.6",
                                    fontFamily: "Monaco, Menlo, 'Ubuntu Mono', Consolas, 'source-code-pro', monospace",
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    overflow: "auto",
                                    maxHeight: "400px",
                                    color: "#333",
                                }, children: api.responseExample }) })] }))] })) : (_jsx("div", { style: { textAlign: "center", padding: "50px" }, children: _jsx(Text, { type: "secondary", children: "\u8BF7\u9009\u62E9\u5DE6\u4FA7\u63A5\u53E3\u67E5\u770B\u8BE6\u60C5" }) })) }));
};
export default CompsApiDetail;
